
(function($) {

  // add twitter bootstrap classes and color based on how many times tag is used

  function addTwitterBSClass(thisObj) {
    var title = $(thisObj).attr('title');
    if (title) {
      var titles = title.split(' ');
      if (titles[0]) {
        var num = parseInt(titles[0]);
        if (num > 0) {
          $(thisObj).addClass('btn btn-xs btn-default');
        }
        if (num === 2) { 
          $(thisObj).addClass('btn btn-xs btn-info');
        }
        if (num > 2 && num < 4) {
          $(thisObj).addClass('btn btn-xs btn-success');
        }
        if (num >= 5 && num < 10) {
          $(thisObj).addClass('btn btn-xs btn-warning');
        }
        if (num >=10) {
          $(thisObj).addClass('btn btn-xs btn-danger');
        }
      }
    }
    else {
      $(thisObj).addClass('btn btn-xs');
    }
    return true;
  }

  // as the page loads, call these scripts
  $(document).ready(function($) {

    // modify tag cloud links to match up with twitter bootstrap
    $("#tag-cloud a").each(function() {
      addTwitterBSClass(this);
      return true;
    });

    $("p.tags a").each(function() {
      addTwitterBSClass(this);
      return true;
    });

    $("ol.commentlist a.comment-reply-link").each(function() {
      $(this).addClass('btn btn-success btn-mini');
      return true;
    });

    $('#cancel-comment-reply-link').each(function() {
      $(this).addClass('btn btn-danger btn-mini');
      return true;
    });

    // $('article.post').hover(function(){
    // 	$('a.edit-post').show();
    // },function(){
    // 	$('a.edit-post').hide();
    // });

    // Prevent submission of empty form
    $('[placeholder]').parents('form').submit(function() {
      $(this).find('[placeholder]').each(function() {
        var input = $(this);
        if (input.val() === input.attr('placeholder')) {
          input.val('');
        }
      });
    });

    $('.alert-message').alert();

    $('.dropdown-toggle').dropdown();

  });

})(jQuery); // Fully reference jQuery after this point.
